import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
let MultipleChoice = class MultipleChoice extends Vue {
  constructor() {
    super(...arguments);
    this.answer = [];
  }
  // eslint-disable-next-line
  watchIndex() {}
  dataChage(value) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer;
      }
    }
  }
  // get questionnaireType() {
  //   return QuestionnaireEditModule.questionnaireType;
  // }
  get getColorForAnswer() {
    if (this.zItem.answered) {
      if (this.zItem.rightAnswer) {
        return "type_green";
      } else if (this.zItem.rightAnswer === null) {
        return "type_yellow";
      } else {
        return "red";
      }
    } else {
      return "c999";
    }
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], MultipleChoice.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], MultipleChoice.prototype, "zIndex", void 0);
__decorate([Prop({
  type: String,
  default: "QUESTIONNAIRE"
})], MultipleChoice.prototype, "questionnaireType", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], MultipleChoice.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})], MultipleChoice.prototype, "watchIndex", null);
__decorate([Prop({
  type: Object,
  default: {}
})], MultipleChoice.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], MultipleChoice.prototype, "dataChage", null);
MultipleChoice = __decorate([Component({
  name: "multipleChoice"
})], MultipleChoice);
export default MultipleChoice;